import React from 'react';
import { IIconProps, IconSizes, IconWidth } from './type';

const CardGeneric: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  color,
  ...props
}) => {
  return (
    <svg
      height={(IconWidth[size] * 2) / 3}
      width={IconWidth[size]}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="35"
        height="23"
        rx="1.5"
        fill="white"
        stroke={color || '#000'}
      />
      <path
        d="M24.0076 5.75C25.3883 5.75 26.5076 6.86929 26.5076 8.25V15.75C26.5076 17.1307 25.3883 18.25 24.0076 18.25H11.5076C10.1269 18.25 9.00757 17.1307 9.00757 15.75V8.25C9.00757 6.86929 10.1269 5.75 11.5076 5.75H24.0076ZM9.94507 15.75C9.94507 16.6129 10.6446 17.3125 11.5076 17.3125H24.0076C24.8705 17.3125 25.5701 16.6129 25.5701 15.75V9.96875H9.94507V15.75ZM15.2576 13.4062C15.5165 13.4062 15.7263 13.6161 15.7263 13.875C15.7263 14.1339 15.5165 14.3438 15.2576 14.3438H11.5076C11.2487 14.3438 11.0388 14.1339 11.0388 13.875C11.0388 13.6161 11.2487 13.4062 11.5076 13.4062H15.2576ZM11.5076 6.6875C10.6446 6.6875 9.94507 7.38706 9.94507 8.25V9.03125H25.5701V8.25C25.5701 7.38706 24.8705 6.6875 24.0076 6.6875H11.5076Z"
        stroke={color || '#000'}
      />
    </svg>
  );
};

export default CardGeneric;
